function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.6.1v6.7h-10.5c-1.3.2-2.7.3-2.5 1.9.3 2 3 2.5 4.6 3.1 3.6 1.5 6.8 2.3 8 6.3.3 1.1.4 2.2.4 3.3.1 12.5-9.6 10.3-21.5 10.3v-6.9h7.3c1.2.1 2.5 0 3.7-.2 1.2-.4 2-1.6 1.7-2.9-.4-1.9-3.4-2.2-5.1-2.8-3-1.2-6.5-2.4-7.5-5.6-.2-1.2-.3-2.3-.2-3.4 0-11.7 10.3-9.8 21.6-9.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.4.1h8.8v15.6c0 2.5-.3 5.5.7 7 .9 1.1 2.1 1.7 3.5 1.8 1.8.3 3.6-.4 4.8-1.7 1.1-1.4.8-4.4.8-6.9v-15.8h8.6l-.2 16.9c-.5 3.1.2 6.3-.8 8.7-1.6 3.7-5.6 5.5-10.2 6.3-1.9.2-3.9.1-5.8-.3-4.3-.9-7.6-2.4-9.2-5.9-1.1-2.5-1-6.1-1-9.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m52.1.1h8.6v24.4h10.8v7.2h-19.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72.8 31.7 5.1-31.6h8.5l5.8 15.6h.1l6.1-15.6h8.5l4.7 31.6h-8.6l-2.1-16.5v.1l-2.1 4.7-4.9 11.7h-3.6l-6.7-17-2.4 17z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m124.7.1h9.2l3.5 9.1 3.8 10.1c1.7 4 3.2 8.2 4.5 12.4l-9.1-.1-7.3-20.6h-.1l-7.2 20.7h-9.2v-.1c2.6-7.1 5.1-14 7.8-20.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m147.1.1h8.9l13.9 18v-18h8.5v31.6h-6.4c-.6 0-1.9.2-2.3-.1l-13.8-18.3v18.5h-8.7c0-10.6 0-21.2-.1-31.7z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m185.8.6c-.5-.7-2.5-.5-3.7-.5-1.4.9-1.9 4.6-.2 5.5.5.2 1.1.2 1.7.1l1.7-.1c1.1-.5 1.3-3.8.5-5zm-.7 4.5c-.9.3-1.9.3-2.9.1-1.5-.7-1-3.7 0-4.4l2.7.1c1.3.4.7 3.3.2 4.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m184.7 3c.2-.5.1-1.2-.2-1.6-.7-.1-1.4-.2-2.1-.1v3.3h.5v-1.4l.5.1.8 1.3h.6l-.6-1.2zm-1.8-.2v-1l1.2.1.1.2v.5c-.4.2-.9.3-1.3.2z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#e30613"
}, /*#__PURE__*/React.createElement("path", {
  d: "m129.3 35.2c.9-.1 1.8.3 2.2 1.1l-.1.1-.5.3-.7-.7c-.8-.3-2.1.2-1.6 1.3.7 1.4 4 1.1 3.4 3.7-.5 2-4.3 1.9-4.7-.1l.6-.3.1.1c.4.9 1.4 1.3 2.3.9.4-.2.7-.5.9-.9 0-.4-.1-.7-.4-1l-2.4-1.2c-1.6-1.2-.5-2.7.9-3.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m146.4 35.3h4.4v.7h-3.5v2.6h3.2v.8h-3.2v3h-.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m155.3 35.3h4.4v.7h-3.6v2.5h3.2v.7h-3.1v2.5h3.7v.7h-4.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m163.9 35.3h5.1v.7h-2.1v6.4h-.8v-6.4h-2.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m176.2 42.4h-.8c.1-3.6-1.3-4.8-2.5-7.1.3 0 .8 0 1 .1.9 1.1 1.5 2.3 1.9 3.6h.1l1.9-3.7h.9c-1.3 2.5-2.5 3.2-2.5 7.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m139.1 35.2h-.2l-2.9 7.2h.8l.7-1.6h3.1l.7 1.6h.8zm-1.5 5 1.3-3.3 1.4 3.3z"
})));

var SvgLogoSafety = function SvgLogoSafety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 186.3 42.5",
    viewBox: "0 0 186.3 42.5"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-safety.59d9a773.svg";
export { SvgLogoSafety as ReactComponent };